import { Tag } from "antd";

export const CustomTagRender = (props) => {
    const { label, closable, onClose } = props;
    return (
        <Tag
            color="blue"
            style={{
                border: "1px solid #1677ff",
                borderRadius: 8,
                padding: "2px 8px",
                marginRight: 4,
                fontSize: 14,
                background: "#f0f7ff",
            }}
            closable={closable}
            onClose={onClose}
        >
            {label}
        </Tag>
    );
};